import { render, staticRenderFns } from "./TheBreadcrumbs.vue?vue&type=template&id=61eb32e2&scoped=true&"
import script from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumbs.vue?vue&type=style&index=0&id=61eb32e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb32e2",
  null
  
)

export default component.exports